import React, { useEffect } from "react";
import { createContext, useState } from "react";
import { fetchCurrentUser } from "../../../services/user_services";

export const UserContext = createContext({ user: null });

const UserState = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetchCurrentUser().then(setUser);
  }, []);

  const contextValue = {
    user,
  }

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
}

export default UserState;
